import IncompleteIcon from './component.jsx'
export default IncompleteIcon
